import { Tree, TreeDataNode, TreeProps } from 'antd';
import React, { useEffect, useState } from 'react';

interface OrganizationTreeProps extends Omit<TreeProps, 'onSelect'> {
  treeData: any[];
  expandedKeys?: React.Key[];
  onExpand?: (keys: React.Key[]) => void;
  selectable?: boolean;
  showLine?: boolean;
  expandAll?: boolean;
  padding?: number;
  onSelect?: (id: number) => void;
}

const getAllKeys = (data: TreeDataNode[]): React.Key[] => {
  const keys: React.Key[] = [];
  const extractKeys = (nodes: TreeDataNode[]) => {
    nodes.forEach(node => {
      keys.push(node.key);
      if (node.children) {
        extractKeys(node.children);
      }
    });
  };
  extractKeys(data);
  return keys;
};

const OrganizationTree: React.FC<OrganizationTreeProps> = ({
  treeData,
  selectable = false,
  showLine = true,
  expandAll = false,
  padding = 0,
  onSelect,
  ...rest
}) => {
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);

  useEffect(() => {
    if (expandAll) {
      const allKeys = getAllKeys(treeData);
      setExpandedKeys(allKeys);
    }
  }, [expandAll, treeData]);

  return (
    <div style={{ padding }}>
      <Tree
        expandedKeys={expandedKeys}
        onExpand={setExpandedKeys}
        treeData={treeData}
        style={{ fontSize: '14px' }}
        selectable={selectable}
        showLine={showLine}
        multiple={false}
        onSelect={(keys, info) => {
          onSelect?.(keys[0] as number);
          // onSelect?.(keys[0] as number, info?.node?.type.toString());
        }}
        {...rest}
      />
    </div>
  );
};

export default OrganizationTree;
